module.exports = __webpack_public_path__ + "files/69117239e0e3fed845132159ee0d4c05.png";